
export const allowedDomains = [
  'labworkz.com', 'scanninja.ai', 'ponderosametalworks.com', 'ponderosaaviation.net'
];
